import { AppRepository } from "../../repositories/app.repository";
import { Injectable } from '@angular/core';
import { ProjectsRepository } from "../../repositories/projects.repository";
/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConnectionProvider {

  constructor(
    public appConfig: AppRepository,
    public projectsRepository: ProjectsRepository
  ) {
    this.appConfig.setInternetConnection(window.navigator.onLine);
  }

  watchOnlineStatus(){

    window.addEventListener('offline', event => {
      this.appConfig.setInternetConnection(false);
      this.appConfig.toggleOfflineMode();
    });

    window.addEventListener('online', event => {
      this.appConfig.setInternetConnection(true);
      this.appConfig.toggleOfflineMode();
      this.syncProjects();
    });

    // this.appConfig.internetConnection$.subscribe(connection => {
    //   if(connection){
    //     this.syncProjects();
    //   }
    // });
  }

  syncProjects(){
    this.projectsRepository.projects$.subscribe( projects => {

      for(let project of projects.projects){
        if(project.dirty && project.saved){
          this.projectsRepository.syncProject( project );
        }
      }

      for(let project of projects.archive){
        if(project.dirty && project.saved){
          this.projectsRepository.syncProject( project );
        }
      }
    }).unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/providers/connection/connection.ts